import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { isLogin } from '@/common/utils/common' // get token from cookie
import getPageTitle from '@/common/utils/get-page-title'
import Vue from 'vue'
import { ZM_ROOT } from '@/common/constants'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/401', '/404'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  if (isLogin()) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      if (store.state.permission.defaultRoute && store.state.permission.defaultRoute.name) {
        next({ name: store.state.permission.defaultRoute.name, replace: true })
      } else {
        next({ path: '/401' })
      }
      NProgress.done()
    } else {
      const isWhite = whiteList.indexOf(to.path) !== -1
      const isRredirect = to.path.indexOf('redirect') > -1
      if (isWhite || isRredirect) {
        next()
      } else {
        const hasRoles = store.getters.roles && store.getters.roles.length > 0
        if (hasRoles) {
          if (to.meta && to.meta.role && store.getters.roles.indexOf(to.meta.role) >= 0) {
            next()
          } else {
            next({ path: '/401' })
          }
          NProgress.done()
        } else {
          try {
            // get user info
            // note: roles must be a object array! such as: ['11'] or ,['11','12']
            const { roles } = await store.dispatch('user/getMenuList')
            // role 为 0 允许访问
            let href = window.location.href
            //TODO: 后台这会儿不能添加菜单。暂时放开
            if (
              href.indexOf('127.0.0.1') !== -1 ||
              href.indexOf('10.0.') !== -1 ||
              href.indexOf('localhost') !== -1
            ) {
              roles.push(0)
            }
            // generate accessible routes map based on roles
            const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
            console.log(accessRoutes)
            // dynamically add accessible routes
            router.addRoutes(accessRoutes)
            console.log(router)
            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
            if (to.path === '/' || to.path === '/dashboard') {
              if (store.state.permission.defaultRoute && store.state.permission.defaultRoute.name) {
                next({ name: store.state.permission.defaultRoute.name, replace: true })
                NProgress.done()
              } else {
                next({ ...to, replace: true })
              }
            } else {
              next({ ...to, replace: true })
            }
          } catch (error) {
            if (error && error.code === 0) {
              if (isLogin()) {
                next({ path: '/401' })
              } else {
                toLogin(to, next)
              }
              NProgress.done()
            } else {
              // remove token and go to login page to re-login
              await store.dispatch('user/resetToken')
              // Message.error(error.message || 'Has Error')
              // next(`/login?redirect=${to.fullPath}`)
              toLogout()
              NProgress.done()
            }
          }
        }
        // determine whether the user has obtained his permission roles through getInfo
      }
    }
  } else {
    /* has no uid*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.fullPath}`)
      toLogin(to, next)
      NProgress.done()
    }
  }
})

router.afterEach(to => {
  // finish progress bar
  NProgress.done()
  orgHasShop(to)
})

//机构如果没有设置店铺，弹窗提示一下
function orgHasShop(to) {
  if (whiteList.indexOf(to.path) !== -1 || to.path === '/shop/info') {
    return
  }
  if (!store.state.user.currentShop) {
    return
  }
  if (store.state.user.currentShop.id) {
    return
  }
  if (!window.localStorage) {
    return
  }

  //check下是否弹出过窗口
  let shopTipsList = JSON.parse(window.localStorage.getItem('shopTips') || '[]')
  if (shopTipsList.indexOf(store.state.user.currentShop.orgId) === -1) {
    shopTipsList.push(store.state.user.currentShop.orgId)
    Vue.prototype
      .$confirm('你还未设置店铺信息，请先去设置店铺信息', '温馨提示', {
        confirmButtonText: '设置店铺信息',
        cancelButtonText: '我先看看',
        center: true
      })
      .then(() => {
        router.push({ name: 'shopInfo' })
        window.localStorage.setItem('shopTips', JSON.stringify(shopTipsList))
      })
      .catch(() => {
        window.localStorage.setItem('shopTips', JSON.stringify(shopTipsList))
      })
  }
}
// 登录
function toLogin(to, next) {
  const href = window.location.href
  const isDev = !href.match(/\.pangmao(.*)\.com/)
  if (!isDev) {
    const jumpLink = href.split('/#')[0]
    let redirect = to.fullPath
    const url = encodeURIComponent(`${jumpLink}/#${redirect}`)
    window.location.href = `${ZM_ROOT}/login?loginType=0&jump=${url}`
  } else {
    next(`/login?redirect=${to.fullPath}`)
  }
}
//登出
function toLogout() {
  const href = window.location.href
  const isDev = !href.match(/\.pangmao(.*)\.com/)
  if (!isDev) {
    const jumpLink = href.split('/#')[0]
    const url = encodeURIComponent(`${jumpLink}/#/`)
    window.location.href = `${ZM_ROOT}/logout?loginType=0&jump=${url}`
  } else {
    router.push(`/login`)
  }
}
